import { createReducer } from "sc/helpers/reducer";
import { DETECTED_LOCATION } from "sc/actions/ui/location";
import { UI_ERROR } from "sc/actions/ui/ui-error";

export const siteReducer = createReducer(null, {
  [DETECTED_LOCATION]: (state, action) => action.payload.location,
});

export const uiErrorReducer = createReducer("", {
  [UI_ERROR]: (state, action) => action.payload.uiError,
});



// WEBPACK FOOTER //
// ./src/sc/reducers/ui-reducers.js